import { Component } from "@angular/core";

@Component({
	templateUrl: "./proxy.component.html",
})
export class ProxyComponent {}
